import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISaveGrammarSessionV2Request } from './save-grammar-session-v2-request';
import type { ISaveGrammarSessionV2Response } from './save-grammar-session-v2-response';
import { saveGrammarSessionV2ResponseSchema } from './save-grammar-session-v2-response';

export async function saveGrammarSessionV2Api(
  body: ISaveGrammarSessionV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISaveGrammarSessionV2Response>> {
  return postRequest<ISaveGrammarSessionV2Response>({
    path: '/grammar/session/v2',
    body,
    schema: saveGrammarSessionV2ResponseSchema,
    options,
  });
}
